import { selector } from 'recoil';
// import { Logger } from '../../common/Logger';
import {
  endpointEnum,
  makeAPIRequest,
} from '../../services/rest/makeAPIRequest';
import { methodNameEnum } from './makePHPRequest';
export const getBusinessProductsPHP = selector({
  key: 'getBusinessProductsPHP',
  get: async ({ get }) => {
    try {
      // const result = await axios.post(
      //   `${process.env.VITE_APP_PHP_DOMAIN}/rest/functions.php?call=getBusinessProducts&businessid=${storageUser.businessid}&apiKey=${storageUser.apikey}`,
      //   {},
      //   { withCredentials: true }
      // );
      const data = {
        call: methodNameEnum.GET_BUSINESS_PRODUCTS,
      };
      const { response } = get(
        makeAPIRequest({
          endpoint: endpointEnum.GET_BUSINESS_PRODUCTS,
          payloadJsonString: JSON.stringify(data),
        })
      );
      const productIdLookup = {
        1: { name: 'Phones' },
        2: { name: 'Local Number' },
        3: { name: 'Toll Free Number' },
        6: { name: 'SMS Response' },
        15: { name: 'Unlimited Minutes Phone' },
        17: { name: 'Basic Phone' },
        19: { name: 'Integrated Phone' },
        21: { name: 'Professional Phone' },
        23: { name: 'Basic Phone Unlimited' },
        24: { name: 'Integrated Phone Unlimited' },
        25: { name: 'Professional Phone Unlimited' },
        26: { name: 'Connection Boost' },
        27: { name: 'FTC Compliance' },
        28: { name: 'Connection Boost Traunch' },
        29: { name: 'Conversation Intelligence' },
        30: { name: 'Power Dialer - 1 Line' },
        31: { name: 'Power Dialer - 4 Line' },
        32: { name: 'Power Dialer - 10 Line' },
        44: { name: 'Power Dialer - AI Human Detect' },
      };
      const result = response?.data?.result.map((obj) => ({
        ...obj,
        priceperunit: '$' + JSON.parse(obj.priceperunit).toFixed(2),
        totalamt:
          '$' + obj.units * JSON.parse(obj.priceperunit) * obj.paymentduration,
        pdescription: productIdLookup[obj.productid]?.name
          ? productIdLookup[obj.productid]?.name
          : ' ',
        // const parsed = JSON.parse(obj.priceperunit);
        // obj.priceperunit = '$' + parsed.toFixed(2);
        // obj.totalamt = '$' + obj.units * parsed * obj.paymentduration;
        // switch (obj.productid) {
        //   case '1':
        //     obj.pdescription = 'Phones';
        //     break;
        //   case '2':
        //     obj.pdescription = 'Local Number';
        //     break;
        //   case '3':
        //     obj.pdescription = 'Toll free Number';
        //     break;
        //   case '6':
        //     obj.pdescription = 'SMS Response';
        //     break;
        //   case '15':
        //     obj.pdescription = 'Unlimited Minutes Phone';
        //     break;
        //   case '17':
        //     obj.pdescription = 'Basic Phone';
        //     break;
        //   case '19':
        //     obj.pdescription = 'Integrated Phone';
        //     break;
        //   case '21':
        //     obj.pdescription = 'Enterprise Phone';
        //     break;
        //   case '23':
        //     obj.pdescription = 'Basic Phone Unlimited';
        //     break;
        //   case '24':
        //     obj.pdescription = 'Integrated Phone Unlimited';
        //     break;
        //   case '25':
        //     obj.pdescription = 'Enterprise Phone Unlimited';
        //     break;
        //   case '26':
        //     obj.pdescription = 'Local Presence Lite';
        //     break;
        //   default:
        //     Logger.info('unexpected product id' + obj.productid);
        //     break;
        // }
      }));
      // console.log(result, 'result in selector look at product id type');
      return result;
    } catch (error) {
      throw error;
    }
  },
});
